var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c("div", { staticClass: "info-div" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t(
                  "__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.tituloPagina"
                )
              ) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "grid-component",
        {
          attrs: {
            columns: _vm.gridColumns,
            data: _vm.gridData,
            "page-index": _vm.pageIndex,
            "page-size": _vm.pageSize,
            "show-edit-item": false,
            "show-remove-item": false,
            "show-select-checkbox": true,
            "show-table-head": true,
            showAddNewButton: false,
            total: _vm.total,
          },
          on: {
            "change-filter-key": _vm.onChangeFilterKey,
            "change-page-size": _vm.onChangePageSize,
            "change-page": _vm.onChangePage,
            "selected-values-changed": _vm.onSelectedValuesChanged,
          },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("div", { staticClass: "filtro-lista" }, [
              _c(
                "button",
                {
                  staticClass: "filtro-avancado-button",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.unfoldedFilter = !_vm.unfoldedFilter
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("__.Crud.filtroAvancado")) +
                      "\n                    "
                  ),
                  _c("i", { staticClass: "fa fa-caret-down" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.unfoldedFilter,
                      expression: "unfoldedFilter",
                    },
                  ],
                  staticClass: "drop-lista",
                },
                [
                  _c(
                    "form",
                    {
                      attrs: { novalidate: "novalidate" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.load($event)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "tipoNota" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.tipoNota"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                staticStyle: { background: "white" },
                                attrs: {
                                  id: "tipoNota",
                                  defaultValue: -1,
                                  name: "tipoNota",
                                  data: _vm.tipoNotaOptions,
                                  searchable: false,
                                },
                                model: {
                                  value: _vm.tipoNota,
                                  callback: function ($$v) {
                                    _vm.tipoNota = $$v
                                  },
                                  expression: "tipoNota",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "emissaoDe" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.emissaoDe"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: { id: "emissaoDe", name: "emissaoDe" },
                                model: {
                                  value: _vm.emissaoDe,
                                  callback: function ($$v) {
                                    _vm.emissaoDe = $$v
                                  },
                                  expression: "emissaoDe",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "emissaoAte" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.emissaoAte"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: { id: "emissaoAte", name: "emissaoAte" },
                                model: {
                                  value: _vm.emissaoAte,
                                  callback: function ($$v) {
                                    _vm.emissaoAte = $$v
                                  },
                                  expression: "emissaoAte",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "apenasNaoCanceladas" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.apenasNaoCanceladas"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("checkbox-component", {
                                staticClass: "checkbox",
                                attrs: {
                                  id: "apenasNaoCanceladas",
                                  name: "apenasNaoCanceladas",
                                },
                                model: {
                                  value: _vm.apenasNaoCanceladas,
                                  callback: function ($$v) {
                                    _vm.apenasNaoCanceladas = $$v
                                  },
                                  expression: "apenasNaoCanceladas",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "botao-filtrar",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("__.Crud.filtrar")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.notasSelecionadas.length > 0,
                  expression: "notasSelecionadas.length > 0",
                },
              ],
              attrs: { slot: "footer-extra-options" },
              slot: "footer-extra-options",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.cancelarEmLote },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "__.Components.parent.notafiscalsaida.cancelamentoDuplicadas.list_vue_html.btnCancelarEmLote"
                        )
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }